import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Products', href: '#products' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export default function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 4);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-40 bg-parchment border-b border-border-warm transition-shadow duration-200 ${
          scrolled ? 'shadow-[0_2px_16px_rgba(22,18,15,0.08)]' : ''
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <a
            href="#"
            className="flex items-center gap-2.5 no-underline"
            aria-label="CTO Imports and Distribution — home"
          >
            <img src="/cto-logo.svg" alt="" className="w-9 h-9" aria-hidden="true" />
            <div className="flex flex-col leading-none">
              <span className="font-serif text-2xl font-normal tracking-[0.06em] text-ink-deep">CTO</span>
              <span className="font-sans text-[0.5rem] font-medium tracking-[0.14em] uppercase text-ink-muted mt-0.5">Import and Distribution</span>
            </div>
          </a>

          <ul className="hidden md:flex items-center gap-10 list-none m-0 p-0" role="list">
            {NAV_LINKS.map(link => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="font-sans text-sm font-normal text-ink-muted hover:text-ink-deep transition-colors duration-150 no-underline"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <a
            href="#contact"
            className="hidden md:inline-flex items-center bg-ink-deep text-parchment px-5 py-2.5 rounded-[2px] font-sans text-[0.6875rem] font-medium tracking-[0.08em] uppercase transition-colors duration-[180ms] hover:bg-gold-edge focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold-edge focus-visible:outline-offset-2"
          >
            Request Catalogue
          </a>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 -mr-2 text-ink-deep"
            onClick={() => setMobileOpen(true)}
            aria-label="Open navigation menu"
            aria-expanded={mobileOpen}
          >
            <Menu size={20} strokeWidth={1.5} />
          </button>
        </div>
      </nav>

      {/* Mobile drawer overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-50"
          aria-modal="true"
          role="dialog"
          aria-label="Navigation"
        >
          <div
            className="absolute inset-0 bg-[rgba(22,18,15,0.35)]"
            onClick={() => setMobileOpen(false)}
          />
          <div
            className="absolute top-0 right-0 bottom-0 w-72 bg-parchment flex flex-col"
            style={{ boxShadow: '0 2px 16px rgba(22,18,15,0.12)' }}
          >
            <div className="flex items-center justify-between px-6 h-16 border-b border-border-warm shrink-0">
              <div className="flex items-center gap-2.5">
                <img src="/cto-logo.svg" alt="" className="w-8 h-8" aria-hidden="true" />
                <div className="flex flex-col leading-none">
                  <span className="font-serif text-2xl font-normal tracking-[0.06em] text-ink-deep">CTO</span>
                  <span className="font-sans text-[0.5rem] font-medium tracking-[0.14em] uppercase text-ink-muted mt-0.5">Import and Distribution</span>
                </div>
              </div>
              <button
                onClick={() => setMobileOpen(false)}
                className="flex items-center justify-center w-10 h-10 -mr-2 text-ink-muted hover:text-ink-deep transition-colors"
                aria-label="Close navigation menu"
              >
                <X size={20} strokeWidth={1.5} />
              </button>
            </div>

            <ul className="flex flex-col list-none m-0 p-0" role="list">
              {NAV_LINKS.map(link => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="flex items-center px-6 py-5 font-serif text-2xl font-light text-ink-deep hover:text-gold-edge transition-colors no-underline border-b border-border-warm"
                    onClick={() => setMobileOpen(false)}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-auto p-6">
              <a
                href="#contact"
                className="flex items-center justify-center bg-ink-deep text-parchment px-5 py-3 rounded-[2px] font-sans text-[0.6875rem] font-medium tracking-[0.08em] uppercase transition-colors duration-[180ms] hover:bg-gold-edge"
                onClick={() => setMobileOpen(false)}
              >
                Request Catalogue
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
